import { Component, OnInit } from '@angular/core';
import { FaqEntry } from 'src/app/shared/entrys/faq.entry';
import { PreguntasFrecuentesService } from './preguntas-frecuentes.service';
import { FaqModel } from 'src/app/shared/models/faq.models';

@Component({
	selector: 'app-preguntas-frecuentes',
	templateUrl: './preguntas-frecuentes.component.html',
	styleUrls: ['./preguntas-frecuentes.component.scss']
})
export class PreguntasFrecuentesComponent implements OnInit {
	faq: Array<FaqModel> = [];
	constructor(private preguntasFrecuentesService: PreguntasFrecuentesService) { }

	ngOnInit() {
		this.preguntasFrecuentesService.get(null).subscribe(resultado => {
			if (resultado.result) {
				this.faq = resultado.data as Array<FaqModel>;
				this.faq.map(dato => {
					dato.isCollapse = true;
					return dato;
				});
			}
		});
	}

	onCollase(model: FaqModel) {
		model.isCollapse = !model.isCollapse;
	}

}
